import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler, PrimariaApi } from "@uxland/primary-shell";
import { InjectAsyncHistoryItemsHandler } from "./handler";

let request: BrokerDisposableHandler;

export const bootstrapInjectAsyncHistoryItems = (broker: BrokerExtensions, api: PrimariaApi) => {
  request = broker.registerRequest(
    api.broker.events.activityHistory.injectAsyncHistoryItemsRequest,
    InjectAsyncHistoryItemsHandler,
  );
};

export const teardownInjectAsyncHistoryItems = () => {
  request?.dispose();
};
